<template>
  <div id="footer" />
</template>

<script>
export default {
  name: 'LayoutFooter',
};
</script>
